import type { ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import type { DiaryType } from "@kiddocare-platform/portal-common/family";
import { isCacheValid } from "../../../entry.cache";
import type { FamilyCacheState } from "../types";

const addDiaryTypesKey: CaseReducer<
  FamilyCacheState,
  PayloadAction<{ key: string; value: ResponseMessage<Array<DiaryType>> }>
> = (state, action) => {
  const { key, value } = action.payload;
  state.diaryTypes[key] = { value, cachedAt: Date.now() };
};

const removeDiaryTypesKey: CaseReducer<
  FamilyCacheState,
  PayloadAction<string>
> = (state, action) => {
  delete state.diaryTypes[action.payload];
};

const purgeExpiredDiaryTypesCache: CaseReducer<FamilyCacheState> = (state) => {
  for (const key of Object.keys(state.diaryTypes)) {
    if (!isCacheValid(state.diaryTypes[key])) {
      delete state.diaryTypes[key];
    }
  }
};

export const diaryTypesReducers = {
  addDiaryTypesKey,
  removeDiaryTypesKey,
  purgeExpiredDiaryTypesCache,
};
